import "../../App.css";

import Aplicativo from "../Aplicativo/Aplicativo";
import BrasilPapayaSection from "../BrasilPapaya/BrasilPapayaSection";
import Discografia from "../Discografia/Discografia";
import Footer from "../Footer/Footer";
import ProximosShowsSection from "../ProximosShows/ProximosShowsSection";
import { useState } from "react";

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);
  const [showCover, setShowCover] = useState(true);

  const handlePlay = () => {
    setShowCover(false);
    const video = document.getElementById("documentario-video");
    if (video) video.play();
  };

  const carouselData = [
    {
      image: "background-1.jpg",
      title: "30 ANOS DE BRASIL PAPAYA",
      subtitle: "Instrumental que pulsa rock, brasilidade e energia",
      description:
        "Desde 1993 derrubando barreiras e provando que música instrumental pode ser visceral, acessível e apaixonante.",
      buttons: [
        { label: "FALE CONOSCO", style: "primary", href: "#footer" },
        { label: "PRÓXIMOS SHOWS", style: "secondary", href: "#agenda" }
      ]
    },
    {
      image: "background-2.png",
      title: "APP BRASIL PAPAYA",
      subtitle: "Afinador, metrônomo e muito mais no seu bolso",
      description:
        "Ferramentas gratuitas para você estudar, ensaiar e cuidar da audição – tudo no mesmo aplicativo.",
      buttons: [{ label: "BAIXAR GRATUITAMENTE", style: "primary", href: "#app" }]
    },
    {
      image: "background-3.png",
      title: "A BRASIL PAPAYA",
      description:
        "Percorre todo o estado com seus shows autorais e versões cheias de identidade. Além disso, colabora frequentemente com a Camerata Florianópolis no consagrado projeto Rock Camerata parceria que já chegou ao palco do Rock in Rio ao lado de Steve Vai.",
      buttons: [{ label: "GALERIA DE FOTOS", style: "primary", href: "https://www.flickr.com/photos/201717672@N02/albums/" }]
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () =>
    setCurrentIndex(prev => (prev === carouselData.length - 1 ? 0 : prev + 1));
  const prevSlide = () =>
    setCurrentIndex(prev => (prev === 0 ? carouselData.length - 1 : prev - 1));
  const goToSlide = index => setCurrentIndex(index);

  const { image, title, subtitle, description } = carouselData[currentIndex];

  return (
    <div className="App" id="home">
      <div className="container">
        <header className="header">
          <div className="logo">
            <a href="#home" onClick={closeMenu}>
              <img src="logo.png" alt="Logo" className="logo-desktop" />
              <img src="logo.png" alt="Logo Celular" className="logo-cell" />
            </a>
          </div>

          <nav className={`menu ${menuOpen ? "open" : ""}`}>
            <ul>
              <li>
                <a href="#discografia" onClick={closeMenu}>Discografia</a>
              </li>
              <li>
                <a href="#banda" onClick={closeMenu}>Banda</a>
              </li>
              <li>
                <a href="#agenda" onClick={closeMenu}>Agenda</a>
              </li>
              <li>
                <a href="https://www.flickr.com/photos/201717672@N02/albums/" onClick={closeMenu}>Galeria de Fotos</a>
              </li>
            </ul>
          </nav>

          <div className="header-buttons">
            {/* <a href="#loja" className="btn loja" onClick={closeMenu}>
              LOJA
              <i className="fas fa-store icon" />
            </a> */}
            <a href="#app" className="btn app" onClick={closeMenu}>
              BAIXE NOSSO APP
              <i className="fas fa-download icon" />
            </a>
          </div>

          <div className="hamburger" onClick={toggleMenu}>
            <div className="bar" />
            <div className="bar" />
            <div className="bar" />
          </div>
        </header>

        <main className="main-content">
          <div className="carousel">
            <div
              className="carousel-image"
              style={{ backgroundImage: `url(${image})` }}
            />

            <div className="carousel-controls">
              <button className="carousel-button prev" onClick={prevSlide}>
                &#10094;
              </button>
              <button className="carousel-button next" onClick={nextSlide}>
                &#10095;
              </button>
            </div>

            <div className="carousel-indicators">
              {carouselData.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${index === currentIndex ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          </div>

          <div className="hero-text">
            <h2>{title}</h2>
            <h1>{subtitle}</h1>
            <p>{description}</p>
            <div className="buttons">
              {carouselData[currentIndex].buttons.map((button, index) => (
                <a
                  key={index}
                  href={button.href}
                  className={`btn-home ${button.style}`}
                  onClick={closeMenu}
                >
                  {button.label}
                  {button.style === "secondary" && <span>&#8599;</span>}
                </a>
              ))}
            </div>
          </div>
        </main>
      </div>

      <section id="discografia">
        <Discografia />
      </section>

      <div className="documentario">
        <a
          href="https://youtu.be/DZyBc-0moT8"
          target="_blank"
          rel="noopener noreferrer"
          className="documentario-link"
        >
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet="documentario_mobile.jpg"
            />
            <img
              src="documentario_desktop.jpg"
              alt="Assistir documentário da Brasil Papaya no YouTube"
              className="documentario-image"
            />
          </picture>
          <div className="video-play-overlay">
            <div className="play-button">
              <i className="fas fa-play"></i>
            </div>
            <p>Clique para assistir ao documentário completo no YouTube</p>
          </div>
        </a>
      </div>

      <section id="banda">
        <BrasilPapayaSection />
      </section>

      <section id="app">
        <Aplicativo />
      </section>

      <section id="agenda">
        <ProximosShowsSection />
      </section>

      <section id="footer">
        <Footer />
      </section>
    </div>
  );
};

export default Home;
